import React from "react"
import Img from "gatsby-image"
import { Container, Carousel } from "react-bootstrap"

export default function OffersCarousel(props) {
  // offer image dimensions: 1160 width x 350 height
  return (
    <Container fluid="lg">
      <Carousel controls={true} indicators={true}>
        {props.CarouselBannerImages.map((banner, index) => (
          <Carousel.Item key={index}>
            <Img
              fluid={banner.image}
              className="d-block w-100 carousel-image"
              alt={banner.altText}
            />
            <Carousel.Caption>{banner.caption}</Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel>
    </Container>
  )
}
